<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button
          type="primary"
          icon="plus"
          class="add-btn"
          @click="visible = true"
        >
          新增大区
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:action="{ tableRow }">
          <div>
            <a-button type="link" size="small" @click="handleEdit(tableRow)">
              编辑
            </a-button>
            <a-divider type="vertical" />
            <a-popconfirm
              title="此操作将删除该项信息, 是否继续?"
              @confirm="handleDeleteConfirm(tableRow)"
            >
              <a-icon slot="icon" type="question-circle-o" class="icon-color" />
              <a-button type="link" size="small">
                删除
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </TableView>
    </a-card>

    <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      :title="modalTitle"
      :maskClosable="false"
      :afterClose="handleAfterClose"
    >
      <a-form :form="modalForm">
        <a-form-item label="所属业务类型">
          <a-select
            v-decorator="$decorator('pid', '请选择所属业务类型')"
            @focus="handleFocus"
          >
            <a-select-option
              v-for="item in selectList"
              :key="item.value"
              :disabled="item.disabled"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="大区">
          <a-input
            :maxLength="100"
            allowClear
            v-decorator="$decorator('name', '大区不能为空')"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import {
  add,
  remove,
  getBusinessTypeList,
  getTableData,
  getFreezeBgList,
} from 'views/setting/api'

export default {
  mixins: [mixin],
  data() {
    return {
      searchCardLoading: true,
      tableLoading: true,
      visible: false,
      modalForm: this.$form.createForm(this),
      modalTitle: '新增',
      selectList: [],
      syList: [], //BG冻结
    }
  },
  components: {
    SearchView,
    TableView,
  },
  mounted() {
    this._getTableData()
    this._getBusinessTypeList()
    this._getFreezeBgList()
  },
  methods: {
    handleFocus() {
      if (this.selectList) {
        this.selectList.forEach(item => {
          item.disabled = false //每次下拉都需要重置禁用属性
        })
      }
      if (this.syList) {
        this.selectList.forEach(item => {
          this.syList.forEach(myitem => {
            if (item.value === myitem.id) {
              item.disabled = true
            }
          })
        })
        this.$forceUpdate() //一定要刷新组件！！！！！！！！！！！！
      }
    },

    // 获取业务类型数据
    _getBusinessTypeList() {
      getBusinessTypeList().then(({ data }) => {
        this.selectList = data.map(item => {
          return {
            text: item.name,
            value: item.id,
          }
        })
        this.searchSchema[2].selectList = [...this.selectList]
      })
    },
    _getFreezeBgList() {
      getFreezeBgList().then(({ data }) => {
        this.syList = data
      })
    },
    // 获取表格数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
        type: 2,
      }

      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },
    // 提交和编辑
    handleSubmit() {
      this.modalForm.validateFields(async (err, values) => {
        if (!err) {
          if (!this.id) {
            this.id = ''
          }

          try {
            const { message } = await add({
              ...values,
              id: this.id,
              type: 2,
            })
            this.visible = false

            this.$notification.success({
              message: '提示',
              description: message,
            })
            this._getTableData()
          } catch (e) {
            // No processing
          }
        }
      })
    },
    // 弹窗关闭
    handleAfterClose() {
      this.id = ''
      this.modalTitle = '新增'
    },
    // 点击编辑
    handleEdit({ name, id, pid }) {
      this.visible = true
      this.modalTitle = '编辑'
      setTimeout(() => {
        this.modalForm.setFieldsValue({
          name,
          pid,
        })
        this.id = id
      }, 20)
    },
    // 删除
    handleDeleteConfirm({ id }) {
      remove(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
  },
}
</script>
